var render = function render(){var _vm=this,_c=_vm._self._c;return _c('competition-list-component',{staticClass:"padding_side",attrs:{"competition-type":'competitionUser',"member-key":_vm.memberKey}})
}
var staticRenderFns = []

export { render, staticRenderFns }